import angular from 'angular';
import _ from 'lodash';

import alertModalTpl from 'auth/views/alert-modal.html';

export default angular.module('user-errorcodes', []).run([
  'gettextCatalog',
  'appFactory',
  function errorCodes(gettextCatalog, appFactory) {
    appFactory.deps.config.errorCodes = _.merge(appFactory.deps.config.errorCodes, {
      user: {
        PRIMARY_ALREADY_REGISTERED: () => ({ title: gettextCatalog.getString('Primary User for this Retailer is already registered.') }),
        INVALID_OWNER_INFORMATION: () => ({ title: gettextCatalog.getString('Owner information not found or is already registered.') }),
        PASSWORD_REQUIRMENTS_NOT_MET: () => ({ title: gettextCatalog.getString('Password requirements not met.') }),
        RETAILER_NOT_IN_SCOPE: () => ({ title: gettextCatalog.getString('Access denied to Retailer. Please contact Administrator.') }),
        /// {{ active }} is Lottery term using to determine User status.
        RETAILER_NOT_FOUND: (params) => ({
          title: gettextCatalog.getString(
            'Retailer is not {{ active }} or does not exist in Retail Management. Please contact Administrator.',
            { active: params.terms.ACTIVE.singular }
          ),
        }),
        NOT_FOUND: () => ({ title: gettextCatalog.getString('Data not found.') }),
        USER_NOT_FOUND: () => ({ title: gettextCatalog.getString('User not found.') }),
        INVALID_EMAIL: () => ({ title: gettextCatalog.getString('Not a well-formed email address.') }),
        WRONG_CHALLENGE_ANSWER: () => ({ title: gettextCatalog.getString('Wrong challenge answer.') }),
        PRIMARY_USER_PRIVILEGE_UPDATE: () => ({ title: gettextCatalog.getString('Cannot update privileges for primary user.') }),
        MULTIPLE_PRIMARY_USER_EXCEPTION: () => ({
          title: gettextCatalog.getString('Primary User for this Retailer is already registered.'),
        }),
        USER_ALREADY_EXIST: (params) => ({
          title: gettextCatalog.getString(
            'User with this e-mail address is already registered. Please call {{ contactPhone }} for assistance.',
            { contactPhone: params.contactPhone }
          ),
        }),
        USER_ALREADY_EXISTS_EXCEPTION: (params) => ({
          title: gettextCatalog.getString(
            'User with this e-mail address is already registered. Please call {{ contactPhone }} for assistance.',
            { contactPhone: params.contactPhone }
          ),
        }),
        USER_NOT_ALLOWED_EMAIL_RESEND: () => ({
          title: gettextCatalog.getString('Activation email resent fails (User is not allowed for email resend).'),
        }),
        USER_NOT_SUSPENDED: (params) => ({
          title: gettextCatalog.getString('Unable to Activate User'),
          /// {{ inactive }} is Lottery term using to determine User status.
          body: gettextCatalog.getString('Sorry, you cannot activate this user because the user status is not {{ inactive }}.', {
            inactive: params.terms.INACTIVE.singular,
          }),
        }),
        USER_STATUS_CHANGE_NOT_ALLOWED: () => ({
          title: gettextCatalog.getString('Unable to Update Account Status'),
          body: gettextCatalog.getString('Sorry, you cannot update account status because the account is suspended.'),
        }),
        USER_NOT_ACTIVE: (params) => ({
          title: gettextCatalog.getString('Unable to Inactivate User'),
          /// {{ active }} is Lottery term using to determine User status.
          body: gettextCatalog.getString('Sorry, you cannot inactivate this user because the user status is not {{ active }}.', {
            active: params.terms.ACTIVE.singular,
          }),
        }),
        PROMOTION_DENIED_MULTISTORE: () => ({
          title: gettextCatalog.getString('Unable to Change Primary User'),
          body: gettextCatalog.getString('Sorry, you cannot change multistore primary user.'),
        }),
        AUTHORIZATION_DATA_NOT_VALID: (params) => ({
          title: gettextCatalog.getString('Unable to create User'),
          body: gettextCatalog.getString('Sorry, we cannot find owner for provided ({{ ownerValidationMethod }}) number.', {
            ownerValidationMethod: params.ownerValidationMethod,
          }),
        }),
        AUTHORIZATION_CHAIN_DATA_NOT_VALID: () => ({
          title: gettextCatalog.getString('Unable to create User'),
          body: gettextCatalog.getString('Sorry, email address does not match retailer.'),
        }),
        ACCOUNT_LOCKED: () => ({ title: gettextCatalog.getString('Sorry, you cannot reset password because this account is suspended.') }),
        MULTIPLE_PRIMARY_USER_WITH_SAME_OWNER_EXCEPTION: () => ({
          title: gettextCatalog.getString(
            'User from that owner already exists, please use another ({{ ownerValidationMethod }}) sequence.',
            { ownerValidationMethod: params.ownerValidationMethod }
          ),
        }),
        IDENTIFICATION_NOT_VALID: () => ({ title: gettextCatalog.getString('Selected user class is incorrect for this retailer number.') }),
        USER_CANNOT_DELETE_ITSELF: () => ({ title: gettextCatalog.getString('User cannot delete itself.') }),
        /// {{ dsr }} is Lottery term using to determine District Sales Representative.
        LOTTERY_REP_ID_NOT_PROVIDED: (params) => ({
          title: gettextCatalog.getString('Admin user has at least one limit to retailers privilege and not set {{ dsr }} id.', {
            dsr: params.terms.DSR.singular,
          }),
        }),
        /// {{ dsr }} is Lottery term using to determine District Sales Representative.
        NOT_ASSIGNED_LOTTERY_REPRESENTATIVE: (params) => ({
          title: gettextCatalog.getString('You are not assigned as {{ dsr }} for selected Retailer.', { dsr: params.terms.DSR.singular }),
        }),
        PASSWORD_ALREADY_USED: () => ({
          title: gettextCatalog.getString('Cannot reuse password'),
          body: gettextCatalog.getString("Cannot reuse old password. Last 3 passwords mustn't repeat."),
          template: alertModalTpl,
        }),
        MAX_CHALLENGE_ANSWER_EXCEEDED: () => ({ title: gettextCatalog.getString('Sorry, you exceeded maximum number of tries.') }),
        BAD_PARAMETER: () => ({ title: gettextCatalog.getString('Sorry, you provided incorrect format in one of search fields.') }),
        USER_WITH_GIVEN_PHONE_ALREADY_EXISTS: () => ({
          title: gettextCatalog.getString(
            "The mobile number you provided is connected to another user's account. Please enter a different mobile number."
          ),
        }),
        PRIMARY_USER_NOT_EXISTS: () => ({
          title: gettextCatalog.getString('Unable to create User'),
          body: gettextCatalog.getString('There is no active primary user'),
        }),
        NOT_AUTHORIZED: (params) => ({
          title: gettextCatalog.getString('User not authorized. Please call {{ contactPhone }} for assistance.', {
            contactPhone: params.contactPhone,
          }),
        }),
      },
      changeprimaryuser: {
        /// {{ inactive }} is Lottery term using to determine User status.
        24: (params) => ({
          title: gettextCatalog.getString('User Access is already set to {{ inactive }}.', { inactive: params.terms.INACTIVE.singular }),
        }),
      },
      suspendactivateusers: {
        23: () => ({
          title: gettextCatalog.getString('Unable to Update Account Status'),
          body: gettextCatalog.getString('Sorry, you cannot update account status because the account is suspended.'),
        }),
        24: (params) => ({
          title: gettextCatalog.getString('Unable to Suspend User'),
          /// {{ inactive }} is Lottery term using to determine User status.
          body: gettextCatalog.getString('Sorry, you cannot suspend this user because user status is {{ inactive }}.', {
            inactive: params.terms.INACTIVE.singular,
          }),
        }),
        25: (params) => ({
          title: gettextCatalog.getString('Unable to Activate User'),
          /// {{ inactive }} is Lottery term using to determine User status.
          body: gettextCatalog.getString('Sorry, you cannot activate this user because the user status is not {{ inactive }}.', {
            inactive: params.terms.INACTIVE.singular,
          }),
        }),
      },
    });
  },
]);



// WEBPACK FOOTER //
// ./src/modules/user/config/errorcodes.conf.js